import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../images/podcast/tek_podcast.png";



function Banner({data}) {
    return (
        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Podcast">
                                <h1>Technology For A Change</h1>
                            </div>
                            <div className="banner_content_txt listing_flex">
                                <p><strong>We discuss the latest trends and technologies with entrepreneurs and global business tycoons. Subscribe to our podcast to get meaningful business insights and stay updated with the hottest technology trends worldwide!</strong></p>
                                <ul>
                                    <li>Innovation</li>
                                    <li>Startups</li>
                                    <li>Trends</li>
                                    <li>Gadgets</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;